import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { TwoFactorAuthenticationMethod } from './enums';

export type TwoFactorAuthenticationDetails = {
  twoFactorAuthenticationMethod: TwoFactorAuthenticationMethod;
};

export interface ITwoFactorAuthenticationService {
  getTwoFactorAuthenticationDetails(): Observable<TwoFactorAuthenticationDetails>;
  removeAppBasedTwoFactorAuth(): Observable<void>;
}

export const TWO_FACTOR_AUTHENTICATION_SERVICE = new InjectionToken<ITwoFactorAuthenticationService>('twoFactorAuthenticationMethod');
